import { Box, Checkbox, FormControl, Grid, List, ListItem, ListItemIcon, ListItemText, makeStyles, MenuItem, Paper, Tab, Tabs, TextField, Typography } from "@material-ui/core";
import clsx from 'clsx';
import AdminTitle from "components/admin/smart-visa/AdminTitle";
import ColorButton from "components/common/ColorButton";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getActionUser, getConfigActionList, getRoleList, setActiveAction } from "redux/modules/configActionSlice";
const useStyles = makeStyles((theme) => ({
    paper: {
        padding: theme.spacing(4),
        borderRadius: 16,
    },
    content: {
        marginTop: 30
    },
    wrapField: {
        width: '100%',
        // paddingLeft: 16
    },
    warpButton: {
        marginTop: 30,
        textAlign: 'right'
    },
    buttonSave: {
        marginLeft: 5,
        width: 120
    },
    menuRow: {
        fontSize: '0.875rem', fontWeight: "500", padding: "10px 15px", borderBottom: "1px solid lightgray", display: "flex", justifyContent: "space-between", alignItems: "center", cursor: "pointer"
    },
    subMenu: {
        marginLeft: "15px", cursor: "pointer", backgroundColor: "whitesmoke", display: "flex", justifyContent: "space-between", alignItems: "center"
    },
    listItem: {
        border: '1px solid lightgray',
        cursor: 'pointer',
        '& span': {
            fontWeight: 500,
            fontSize: 13,
        }
    },
    actionSelected: {
        backgroundColor: theme.palette.primary.main,
        color: '#fff'
    },
    roleCheckbox: {
        height: 20
    }
}));

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}


function PersonalPage() {

    const classes = useStyles();
    const dispatch = useDispatch();
    const [value, setValue] = React.useState(0);
    const { list: roleList, isLoading } = useSelector((state) => state.role);
    const { list: actionList, actions } = useSelector((state) => state.configAction);
    const { profile } = useSelector((state) => state.user);

    const [state, setAction] = useState({
        actions: [],
        actionSelected: ''
    });


    useEffect(() => {
        async function fetchData() {
            await dispatch(getConfigActionList());
            await dispatch(getRoleList());
            await dispatch(getActionUser(profile.userID));
        }
        fetchData();
    }, []);


    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const handleOnSelectSubMenu = (actionMenu) => {
        const actionNo = (actionMenu.length > 0) ? actionMenu[0].actionNo : null;

        const _actions = JSON.parse(JSON.stringify(actionMenu));

        const actionNoList = actions.map(x => x.actionNo);

        console.log(actionNoList);
        _actions.filter(x => actionNoList.indexOf(x.actionNo) > -1).forEach(m => {
            console.log(m);
            m.selected = true;
        });

        setAction({ actions: _actions, actionSelected: actionNo })
        dispatch(setActiveAction(actionNo));
    }


    const handleChangeAction = (checked, item) => {

        item.selected = !item.selected;
        console.log(checked);
        console.log(item);
    }


    return (
        <Paper className={classes.paper}>
            <AdminTitle title="Setting" subTitle="Personal" />


            <div className={classes.content}>

                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <Tabs value={value} onChange={handleChange}>
                        <Tab label="Personal Information" />
                        <Tab label="Actions" />
                    </Tabs>
                </Box>
                <TabPanel value={value} index={0}>
                    <Grid container spacing={3}>
                        <Grid item xs={12} md={4}>
                            <FormControl className={classes.wrapField}>
                                <TextField id="outlined-basic" label="Employee No" variant="outlined" />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <FormControl className={classes.wrapField}>
                                <TextField id="outlined-basic" label="Firstname" variant="outlined" />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <FormControl className={classes.wrapField}>
                                <TextField id="outlined-basic" label="Lastname" variant="outlined" />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <FormControl className={classes.wrapField}>
                                <TextField id="outlined-basic" label="Email" variant="outlined" type="email" />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <FormControl className={classes.wrapField}>
                                <TextField id="outlined-basic" label="UMID" variant="outlined" />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <FormControl className={classes.wrapField}>
                                <TextField id="outlined-basic" label="Position" variant="outlined" />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <FormControl className={classes.wrapField}>
                                <TextField
                                    variant="outlined"
                                    select
                                    label="Role"
                                >
                                    {
                                        roleList.filter(x => x.status === 'Y').map((row, index) => (
                                            <MenuItem key={row.roleId} value={row.roleId}>
                                                {row.roleName}
                                            </MenuItem>

                                        ))
                                    }
                                </TextField>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} md={4}>

                            <FormControl className={classes.wrapField}>
                                <TextField
                                    variant="outlined"
                                    select
                                    label="Status"
                                >
                                    <MenuItem value={'Y'}>Active</MenuItem>
                                    <MenuItem value={'N'}>Inactive</MenuItem>
                                </TextField>
                            </FormControl>

                        </Grid>
                        <Grid item xs={12} md={4}>
                            <FormControl className={classes.wrapField}>
                                <TextField id="outlined-basic" label="Pin" variant="outlined" type="password" />
                            </FormControl>
                        </Grid>

                    </Grid>
                    <div
                        style={{
                            marginTop: 44,
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "center",
                        }}
                    >
                        <ColorButton
                            style={{ height: 40, width: 125, marginLeft: 20 }}
                            variant="contained"
                            color="primary"
                            type="submit"
                        >
                            Save
                        </ColorButton>
                    </div>
                </TabPanel>
                <TabPanel value={value} index={1}>
                    <Grid container spacing={3}>
                        <Grid item xs={12} md={5}>
                            <h4>Category</h4>
                            <div>
                                {
                                    actionList.map(l => (
                                        <div key={l.menuNo}>
                                            <div className={classes.menuRow}>
                                                <div>
                                                    {l.menuName}
                                                </div>
                                            </div>
                                            {l.subMenu.map(s => (
                                                <div className={clsx(classes.menuRow, classes.subMenu)} key={s.subMenuNo}
                                                    onClick={() => handleOnSelectSubMenu(s.actionMenu)}>

                                                    <div>
                                                        {s.subMenuName}
                                                    </div>

                                                </div>

                                            ))}

                                        </div>
                                    ))

                                }
                            </div>
                        </Grid>
                        <Grid item xs={12} md={7}>
                            <h4>Action</h4>

                            <List>
                                {
                                    state.actions.map((row, index) => (
                                        <ListItem key={index} className={clsx(classes.listItem)}>

                                            <ListItemIcon>
                                                <Checkbox className={classes.roleCheckbox}
                                                    color="primary"
                                                    edge="start"
                                                    spacing={1}
                                                    tabIndex={-1}
                                                    checked={row.selected}
                                                    onChange={(e) => handleChangeAction(e.target.checked, row)}
                                                    disableRipple
                                                />
                                            </ListItemIcon>
                                            <ListItemText
                                                primary={`(${row.actionNo}) - ${row.actionName}`}
                                            />
                                        </ListItem>

                                    ))
                                }
                            </List>
                        </Grid>

                    </Grid >
                    <div
                        style={{
                            marginTop: 44,
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "center",
                        }}
                    >
                        <ColorButton
                            style={{ height: 40, width: 125, marginLeft: 20 }}
                            variant="outlined"
                            color="primary"
                            type="submit"
                        >
                            Renew
                        </ColorButton>
                        <ColorButton
                            style={{ height: 40, width: 125, marginLeft: 20 }}
                            variant="contained"
                            color="primary"
                            type="submit"
                        >
                            Save
                        </ColorButton>
                    </div>
                </TabPanel>
            </div>

        </Paper >
    );
}

export default PersonalPage;
